import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { differenceInDays, formatDistance } from 'date-fns';
import { enUS, da } from 'date-fns/locale'

@Pipe({
  name: 'timeDistance'
})
export class TimeDistancePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(value: Date, ...args: [Date | undefined]): unknown {
    const baseDate = args.length > 0 ? args[0] : undefined;
    if(!baseDate) {
      return '';
    }
    
    const days = differenceInDays(baseDate, value);
    let distance;
    if(days < 182) {
      distance = days / 7;
      return $localize`${formatNumber(distance, this.locale, '1.0-1')} weeks ago`;
    } else {
      distance = formatDistance(value, baseDate, {locale:this.resolveLocale()});
      return $localize`${distance} ago`;
    }
     
    
  }

  private resolveLocale() {
    switch(this.locale) {
      case 'da':
        return da;
      default: 
        return enUS;
    }
  }
}
